import { useEffect, useRef, useState } from 'react';

/**
 * 📷 Fotos, die im Hintergrund hochladen (22.10.2026, Wunsch Philipp für Folkert): Seit die Annahme zuerst ohne Foto
 * bucht (schneller) und Turbo das PaketPilot-Foto nachreicht, laufen Uploads nach dem Piep weiter. Die Anzeige
 * „📷 3/5" mit Drehsymbol zeigt, dass noch nicht alles oben ist — damit am Ende niemand die App schließt, solange Fotos fehlen.
 *
 *   const [fotoStand, verfolge] = useFotoZaehler();
 *   verfolge(promiseDieTrueOderFalseLiefert);
 *   <FotoStand stand={fotoStand} text={(f, g) => `${f}/${g} Fotos hochgeladen`} />
 */
export function useFotoZaehler() {
  const [stand, setStand] = useState({ gesamt: 0, fertig: 0, fehler: 0 });
  const lebt = useRef(true);
  useEffect(() => () => { lebt.current = false; }, []);
  const verfolge = (promise) => {
    setStand((s) => ({ ...s, gesamt: s.gesamt + 1 }));
    const fertig = (ok) => { if (lebt.current) setStand((s) => ({ ...s, fertig: s.fertig + 1, fehler: s.fehler + (ok ? 0 : 1) })); };
    Promise.resolve(promise).then((ok) => fertig(ok !== false), () => fertig(false));
    return promise;
  };
  return [stand, verfolge];
}

export const fotosOffen = (stand) => Math.max(0, (stand?.gesamt || 0) - (stand?.fertig || 0));

const Dreher = () => (
  <svg width="16" height="16" viewBox="0 0 50 50" style={{ verticalAlign: '-3px' }} aria-hidden="true">
    <circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" strokeWidth="6" strokeDasharray="90 40" strokeLinecap="round">
      <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.9s" repeatCount="indefinite" />
    </circle>
  </svg>
);

/** Zeile „📷 3/5 …" — nur sichtbar, wenn in dieser Sitzung Fotos hochgeladen werden/wurden */
export default function FotoStand({ stand, text, fehlerText, dark, hell }) {
  if (!stand || !stand.gesamt) return null;
  const offen = fotosOffen(stand);
  const farbe = hell ? '#fff' : offen ? (dark ? '#ffe082' : '#8d6e00') : (dark ? '#a5d6a7' : '#2e7d32');
  return (
    <div data-testid="foto-stand" data-offen={offen} style={{ marginTop: 8, fontSize: 13, fontWeight: 600, color: farbe, display: 'flex', alignItems: 'center', gap: 6 }}>
      {offen ? <Dreher /> : <span>✓</span>}
      <span>📷 {text(stand.fertig, stand.gesamt)}{stand.fehler && fehlerText ? ` · ⚠️ ${fehlerText(stand.fehler)}` : ''}</span>
    </div>
  );
}
